import React, { Component } from 'react'
import ReactModal from 'react-modal';

import { expectRevert, time } from '@openzeppelin/test-helpers';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BigNumber from "bignumber.js";
import {BLOCKS_PER_YEAR, CAKE_PER_BLOCK} from "../config";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    Link
} from "react-router-dom";

import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

/*
import {
    Multicall,
    ContractCallResults,
    ContractCallContext,
} from 'ethereum-multicall';
 */

//import { MultiCall } from 'eth-multicall'

//import { Contract, Provider } from 'ethers-multicall';

import {
    Interface
} from "@ethersproject/abi";

import Timelock from '../abis/Timelock.json';

import SlionToken from '../abis/SlionToken.json';
import MlionToken from '../abis/MlionToken.json';
import XlionToken from '../abis/XlionToken.json';

import MasterChef from '../abis/MasterChef.json';
import MasterChefMegaLion from '../abis/MasterChefMegaLion.json';
import WBNBPool from '../abis/WBNBPool.json';
import MasterChefXlion from '../abis/MasterChefXtraLion.json';

import ChangeSlionForXlion from '../abis/ChangeSlionForXlion.json';

import Menu from './Menu'
import Main from './Main'
import Home from './Home'
//import Farms from "./Farms";
//import Pools from "./Pools";
import Earn from "./Earn";
import Referral from "./Referral";
import Audit from "./Audit";
import TheGame from "./TheGame";
import Whitepaper from "./Whitepaper";
import ScrollToTop from "./ScrollToTop";
import PoolSingle from "./PoolSingle";

import ERC20 from '../config/abi/erc20.json'
import MultiCallAbi from '../config/abi/Multicall.json'
import lpToken from '../config/abi/lpToken.json'

//import { $ }  from 'react-jquery-plugin'

import './App.css'

import Apy from '../utils/apy'

import {HttpProviderOptions} from "web3-core-helpers";
import {Nav, Navbar, NavDropdown} from "react-bootstrap";
import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";
import KycPage from "./KycPage";
import EditProfilePage from "./EditProfilePage";
import TheGameNftSingle from "./TheGameNftSingle";


/**/
/*
const networkId = 97
const networkIdHex = '0x61';
//const web3Provider = 'https://data-seed-prebsc-1-s1.binance.org:8545/';
//const web3Provider = 'https://data-seed-prebsc-2-s1.binance.org:8545/';
const web3Provider = 'https://data-seed-prebsc-2-s3.binance.org:8545/';
const bscscanUrlTx = 'https://testnet.bscscan.com/tx/';

*/

const networkId = 56
const networkIdHex = '0x38';
const web3Provider = 'https://bsc-dataseed.binance.org/';
//const web3Provider = 'https://bsc-dataseed1.ninicoin.io/';
//const web3Provider = 'https://bsc-dataseed1.binance.org:443';
//const web3Provider = 'https://bsc-dataseed1.defibit.io';
const bscscanUrlTx = 'https://bscscan.com/tx/';


const userDashboardURL = 'https://kyc.cryptogirl.finance/user/dashboard';
const checkUserUrl = 'https://kyc.cryptogirl.finance/api/v1/check-user-login';
const saveTransactionUrl = 'https://kyc.cryptogirl.finance/api/v1/save-transaction';



const TimelockData = Timelock.networks[networkId]

const MasterChefData = MasterChef.networks[networkId]
const MasterChefMegaLionData = MasterChefMegaLion.networks[networkId]
const WBNBPoolData = WBNBPool.networks[networkId]
const MasterChefXlionData = MasterChefXlion.networks[networkId]

const ChangeSlionForXlionData = ChangeSlionForXlion.networks[networkId]

const SlionTokenData = SlionToken.networks[networkId]
const MlionTokenData = MlionToken.networks[networkId]
const XlionTokenData = XlionToken.networks[networkId]


const TimelockAddress = TimelockData.address;

const MasterChefAddress = MasterChefData.address;
const MasterChefMegaLionAddress = MasterChefMegaLionData.address;
const WBNBPoolAddress = WBNBPoolData.address;
const MasterChefXlionAddress = MasterChefXlionData.address;

const ChangeSlionForXlionAddress = ChangeSlionForXlionData.address;

const SlionTokenAddress = SlionTokenData.address;
const MlionTokenAddress = MlionTokenData.address;
const XlionTokenAddress = XlionTokenData.address;


/**/
console.log('TimelockAddress');
console.log(TimelockAddress);

console.log('MasterChefAddress');
console.log(MasterChefAddress);

console.log('MasterChefMegaLionAddress');
console.log(MasterChefMegaLionAddress);

console.log('WBNBPoolAddress');
console.log(WBNBPoolAddress);

console.log('MasterChefXlionAddress');
console.log(MasterChefXlionAddress);

console.log('ChangeSlionForXlionAddress');
console.log(ChangeSlionForXlionAddress);

console.log('SlionTokenAddress');
console.log(SlionTokenAddress);

console.log('MlionTokenAddress');
console.log(MlionTokenAddress);

console.log('XlionTokenAddress');
console.log(XlionTokenAddress);


const notifyOk = (hash) => {
    let notifyContent = <div>
        All right!<br />
        <a target="_blank" href={bscscanUrlTx + hash }>View on Bscscan</a>
    </div>;

    toast.success(notifyContent, {
        position: "top-left",
        autoClose: 5000,
    });
}

const notifyNoOk = (hash) => {
    let notifyContent = <div>
        Oooooppsss!<br />
        <a target="_blank" href={bscscanUrlTx + hash }>View on Bscscan</a>
    </div>;

    toast.error(notifyContent, {
        position: "top-left",
        autoClose: 5000,
    });
}

class App extends Component {

    getTokenContractsDataAndAdress() {
        /* SLION */
        this.state.ourTokenName = 'SLION';
        this.state.ourTokenContract = SlionTokenAddress;
        this.state.SlionTokenData = SlionTokenData;

        /* MLION */
        this.state.ourSecondTokenName = 'MLION';
        this.state.ourSecondTokenContract = MlionTokenAddress;
        this.state.MlionTokenData = MlionTokenData;

        /* XLION */
        this.state.ourXlionTokenName = 'XLION';
        this.state.ourXlionTokenContract = XlionTokenAddress;
        this.state.XlionTokenData = XlionTokenData;

    }

    getTokenAdditionalInfo() {
        /* SLION */
        this.state.SlionToken = {};

        this.state.SlionTokenBalance = '0';
        this.state.stakingBalance = '0';
        this.state.ourTokenPrice = '-';

        this.state.totalTokenBurned = 0;
        this.state.totalAllocPoint = 0;
        this.state.tokensInYourWallet = 0;

        /* MLION */
        this.state.MlionToken = {};

        this.state.MlionTokenBalance = '0';
        this.state.MlionStakingBalance = '0';
        this.state.ourSecondTokenPrice = '-';

        this.state.ourSecondTotalTokenBurned = 0;
        this.state.ourSecondTotalAllocPoint = 0;
        this.state.secondTokenTokensInYourWallet = 0;

        /* XLION */
        this.state.XlionToken = {};

        this.state.XlionTokenBalance = '0';
        this.state.XlionStakingBalance = '0';
        this.state.ourTokenXlionPrice = '-';

        this.state.ourXlionTotalTokenBurned = 0;
        this.state.ourXlionTotalAllocPoint = 0;
        this.state.xlionTokenTokensInYourWallet = 0;
        this.state.xlionTokentransferTaxRate = 0;
        this.state.xlionTokenMaxTransferAmountRate = 0;
        this.state.maxTransferAmountRatePercent = 0;

    }

    getContractsDataAndAdress() {
        const TimelockContract = new window.web3.eth.Contract(Timelock.abi, TimelockAddress);

        const MasterChefContract = new window.web3.eth.Contract(MasterChef.abi, MasterChefAddress);
        const MasterChefMegaLionContract = new window.web3.eth.Contract(MasterChefMegaLion.abi, MasterChefMegaLionAddress);
        const WBNBPoolContract = new window.web3.eth.Contract(WBNBPool.abi, WBNBPoolAddress);
        const MasterChefXlionContract = new window.web3.eth.Contract(MasterChefXlion.abi, MasterChefXlionAddress);

        const ChangeSlionForXlionContract = new window.web3.eth.Contract(ChangeSlionForXlion.abi, ChangeSlionForXlionAddress);

        const SlionTokenContract = new window.web3.eth.Contract(SlionToken.abi, SlionTokenAddress);
        const MlionTokenContract = new window.web3.eth.Contract(MlionToken.abi, MlionTokenAddress);
        const XlionTokenContract = new window.web3.eth.Contract(XlionToken.abi, XlionTokenAddress);

        /* ADDRESS */
        this.state.MasterChefAddress = MasterChefAddress;
        this.state.MasterChefMegaLionAddress = MasterChefMegaLionAddress;
        this.state.WBNBPoolAddress = WBNBPoolAddress;

        this.state.ChangeSlionForXlionAddress = ChangeSlionForXlionAddress;
        this.state.MasterChefXlionAddress = MasterChefXlionAddress;

        /* DATA */
        this.state.MasterChefData = MasterChefData;
        this.state.MasterChefMegaLionData = MasterChefMegaLionData;
        this.state.WBNBPoolData = WBNBPoolData;

        this.state.ChangeSlionForXlionData = ChangeSlionForXlionData;
        this.state.MasterChefXlionData = MasterChefXlionData;

        /* CONTRACTS */
        this.state.TimelockContract = TimelockContract;

        this.state.MasterChefContract = MasterChefContract;
        this.state.MasterChefMegaLionContract = MasterChefMegaLionContract;
        this.state.WBNBPoolContract = WBNBPoolContract;

        this.state.ChangeSlionForXlionContract = ChangeSlionForXlionContract;
        this.state.MasterChefXlionContract = MasterChefXlionContract;

        this.state.SlionTokenContract = SlionTokenContract;
        this.state.MlionTokenContract = MlionTokenContract;
        this.state.XlionTokenContract = XlionTokenContract;

        /* ADDITIONALS */
        this.state.changeTokensData = {
            lastBlockToDepositSlion: 0,
            firstBlockToWithdraw: 0,
            maxSlionInDeposit: 0,
            slionDeposited: 0,
            xlionPerSlion: 0,
        };
    }

    getMasterChefAddressByNum(numMasterchef) {

        let masterChefAddress = '';

        switch (numMasterchef) {
            case 0:
                masterChefAddress  = this.state.MasterChefAddress;
                break;
            case 1:
                masterChefAddress  = this.state.MasterChefMegaLionAddress;
                break;
            case 2:
                masterChefAddress  = this.state.WBNBPoolAddress;
                break;
            case 3:
                masterChefAddress  = this.state.ChangeSlionForXlionAddress;
                break;
            case 4:
                masterChefAddress  = this.state.MasterChefXlionAddress;
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return masterChefAddress;
    }

    getAuthUserData() {
        fetch(checkUserUrl, {
            method: 'POST',
            //origin: 'http://authdefi.xtralion.finance',
            credentials: 'include',
        })
            .then(response => response.json())
            .then((jsonData) => {

                console.log('jsonData');
                console.log(jsonData);

                if (jsonData.success) {
                    this.state.userEmail = jsonData.email;
                } else {
                    this.state.userEmail = null;
                }

        });
    }

    getMasterChefContractByNum(numMasterchef) {

        let masterChefContract = '';

        switch (numMasterchef) {
            case 0:
                masterChefContract  = this.state.MasterChefContract;
                break;
            case 1:
                masterChefContract  = this.state.MasterChefMegaLionContract;
                break;
            case 2:
                masterChefContract  = this.state.WBNBPoolContract;
                break;
            case 3:
                masterChefContract  = this.state.ChangeSlionForXlionContract;
                break;
            case 4:
                masterChefContract  = this.state.MasterChefXlionContract;
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return masterChefContract;
    }

    getMasterChefABIByNum(numMasterchef) {

        let masterChefContract = '';

        switch (numMasterchef) {
            case 0:
                masterChefContract  = MasterChef.abi;
                break;
            case 1:
                masterChefContract  = MasterChefMegaLion.abi;
                break;
            case 2:
                masterChefContract  = WBNBPool.abi;
                break;
            case 3:
                masterChefContract  = ChangeSlionForXlion.abi;
                break;
            case 4:
                masterChefContract  = MasterChefXlion.abi;
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return masterChefContract;
    }

    async getPoolInfoSingleByMasterchefNum(numMasterchef, pid) {

        let masterChefContract = this.getMasterChefContractByNum(numMasterchef);
        let poolInfoSingle = await masterChefContract.methods.poolInfo(pid).call();

        return poolInfoSingle;
    }

    async getTotalAllocPointAndCurrentBlockFromBlockChain() {
        let totalAllocPoint = await this.getMasterChefContractByNum(0).methods.totalAllocPoint().call();
        let ourSecondTotalAllocPoint = await this.getMasterChefContractByNum(1).methods.totalAllocPoint().call();
        let ourXlionTotalAllocPoint = await this.getMasterChefContractByNum(4).methods.totalAllocPoint().call();
        let currentBlock = await window.web3.eth.getBlockNumber();

        this.state.totalAllocPoint = totalAllocPoint;
        this.state.ourSecondTotalAllocPoint = ourSecondTotalAllocPoint;
        this.state.ourXlionTotalAllocPoint = ourXlionTotalAllocPoint;
        this.state.currentBlock = currentBlock;
    }

    async loadMasterChefStats() {
        let slionPerBlock = await this.state.MasterChefContract.methods.slionPerBlock().call()
        let slionPerBlockEther = window.web3.utils.fromWei(slionPerBlock, 'Ether');

        let mlionPerBlock = await this.state.MasterChefMegaLionContract.methods.mlionPerBlock().call()
        let mlionPerBlockEther = window.web3.utils.fromWei(mlionPerBlock, 'Ether');

        let xlionPerBlock = await this.state.MasterChefXlionContract.methods.xlionPerBlock().call()
        let xlionPerBlockEther = window.web3.utils.fromWei(xlionPerBlock, 'Ether');

        this.setState({
            slionPerBlockEther: slionPerBlockEther,
            mlionPerBlockEther: mlionPerBlockEther,
            xlionPerBlockEther: xlionPerBlockEther,
        });
    }

    getTokensPerBlockByMasterchefNum(numMasterchef) {
        let tokensPerBlock = 1;

        switch (numMasterchef) {
            case 0:
                tokensPerBlock = this.state.slionPerBlockEther;
                break;
            case 1:
                tokensPerBlock = this.state.mlionPerBlockEther;
                break;
            case 2:
                tokensPerBlock = 0.000034722222222;
                break;
            case 3:
                tokensPerBlock = 0;
                break;
            case 4:
                tokensPerBlock = this.state.xlionPerBlockEther;
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return tokensPerBlock;
    }

    getTotalAllocPointByMasterchefNum(numMasterchef) {

        let totalAllocPoint = 1000;

        switch (numMasterchef) {
            case 0:
                totalAllocPoint  = this.state.totalAllocPoint;
                break;
            case 1:
                totalAllocPoint  = this.state.ourSecondTotalAllocPoint;
                break;
            case 2:
                //BNB POOL...
                break;
            case 3:
                //CHANGE SLION x XLION
                break;
            case 4:
                totalAllocPoint  = this.state.ourXlionTotalAllocPoint;
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return totalAllocPoint;
    }

    getRewardTokenPriceByMasterchefNum(numMasterchef) {
        let rewardTokenPrice = 1;

        switch (numMasterchef) {
            case 0:
                rewardTokenPrice = this.state.ourTokenPrice;
                break;
            case 1:
                rewardTokenPrice = this.state.ourSecondTokenPrice;
                break;
            case 2:
                rewardTokenPrice = this.state.bnbPrice;
                break;
            case 3:
            case 4:
                rewardTokenPrice = this.state.ourTokenXlionPrice;
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return rewardTokenPrice;
    }

    getEarnTokenNameByMasterchefNum(numMasterchef) {
        let earnTokenName = '.';

        switch (numMasterchef) {
            case 0:
                earnTokenName = this.state.ourTokenName;
                break;
            case 1:
                earnTokenName = this.state.ourSecondTokenName;
                break;
            case 2:
                earnTokenName = <strong style={{ color: 'orange' }}>WBNB</strong>;
                break;
            case 3:
            case 4:
                earnTokenName = this.state.ourXlionTokenName;
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return earnTokenName;
    }

    getDepositFeeTextByMasterchefNum(numMasterchef) {
        let depositFeeText = '.';

        switch (numMasterchef) {
            case 0:
                depositFeeText = 'deposit fee';
                break;
            case 1:
                depositFeeText = 'deposit fee';
                break;
            case 2:
                depositFeeText = 'BURN Deposit Fee';
                break;
            case 3:

                break;
            case 4:
                depositFeeText = 'deposit fee';
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return depositFeeText;
    }


    getDepositMethodMasterChefContractByNum(numMasterchef, pid, amount) {

        let masterChefContract = this.getMasterChefContractByNum(numMasterchef);

        let depositFunction = '';

        if (numMasterchef == 2) {
            depositFunction = masterChefContract.methods.deposit(amount);
        } else if (numMasterchef == 3) {
            depositFunction = masterChefContract.methods.depositSlion(pid, amount);
        } else {
            let ref = this.getCookie('ref');
            depositFunction = masterChefContract.methods.deposit(pid, amount);

            if (ref) {
                depositFunction = masterChefContract.methods.deposit(pid, amount, ref);
            }
        }

        return depositFunction;
    }

    getWithdrawMethodMasterChefContractByNum(numMasterchef, pid, amount) {
        let withdrawFunction = '';

        let masterChefContract = this.getMasterChefContractByNum(numMasterchef);

        if (numMasterchef == 2) {
            withdrawFunction = masterChefContract.methods.withdraw(amount);
        } else if (numMasterchef == 3) {
            withdrawFunction = masterChefContract.methods.collectXlion(pid);
        } else {
            withdrawFunction = masterChefContract.methods.withdraw(pid, amount);
        }

        return withdrawFunction;
    }

    async getUserInfoByMasterChefNum(numMasterchef, account, pid) {

        let masterchefContract = this.getMasterChefContractByNum(numMasterchef);

        let userInfo = null;

        if (numMasterchef == 2){
            userInfo = await masterchefContract.methods.userInfo(account).call()
        } else {
            userInfo = await masterchefContract.methods.userInfo(pid, account).call()
        }

        /*
        if (numMasterchef == 4 && pid == 0) {
            userInfo.amount = (parseFloat(userInfo.amount) * 0.985).toString();
        }
        */

        return userInfo;
    }

    getUserPendingTokensFunctionNameByMasterChefNum(numMasterchef) {
        let functionName = '';

        switch (numMasterchef) {
            case 0:
                functionName = 'pendingSlion';
                break;
            case 1:
                functionName = 'pendingMlion';
                break;
            case 2:
                functionName = 'pendingReward';
                break;
            case 3:
                functionName = 'getPendingXlionByUser';
                break;
            case 4:
                functionName = 'pendingXlion';
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return functionName;
    }

    async getUserPendingTokensByMasterChefNum(numMasterchef, account, pid) {
        let rewardPendingTokens = 0;
        let masterchefContract = this.getMasterChefContractByNum(numMasterchef);

        switch (numMasterchef) {
            case 0:
                rewardPendingTokens = await masterchefContract.methods.pendingSlion(pid, account).call();
                break;
            case 1:
                rewardPendingTokens = await masterchefContract.methods.pendingMlion(pid, account).call();
                break;
            case 2:
                rewardPendingTokens = await masterchefContract.methods.pendingReward(account).call();
                break;
            case 3:
                rewardPendingTokens = await masterchefContract.methods.getPendingXlionByUser(pid, account).call();
                break;
            case 4:
                rewardPendingTokens = await masterchefContract.methods.pendingXlion(pid, account).call();
                break;
            default:
                alert('NOT FOUND MasterChef #' + numMasterchef);
        }

        return rewardPendingTokens;
    }

    getTokenPriceSpecial(contract) {
        if (contract == SlionTokenAddress.toLowerCase()) {
            return this.state.ourTokenPrice;
        }

        if (contract == MlionTokenAddress.toLowerCase()) {
            return this.state.ourSecondTokenPrice;
        }

        if (contract == XlionTokenAddress.toLowerCase()) {
            return this.state.ourTokenXlionPrice;
        }

        if (contract == '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c') {
            return this.state.bnbPrice;
        }

        if (contract == '0x35587fb890dc92cc295b4759f8159a3c7f2f3b60') {
            return 1;
        }

        return null;
    }

    constructor(props) {

        super(props)

        //setTimeout(() => {
            //this.loadCountdown();
        //}, 10000);


        let url = new URL(window.location.href);
        let ref = url.searchParams.get('ref');

        if (ref) {
            this.setCookie('ref', ref, 999);
        }

        const web3 = new Web3();
        web3.setProvider(new Web3.providers.HttpProvider(web3Provider));

        window.web3 = web3;

        this.state = {
            account: '0x0',
            userEmail: null,

            tokenPrices: [],
            pairsPrices: [],

            BusdPerBNB: 0,

            loading: true,
            showModal: false,
            modalContent: 'aaa',
            tvl: 0,

            defiName: 'CryptoGirl',
            defiUrl: 'https://cryptogirl.finance/',

            pools: [],
            poolsDepositToken: [],
            poolsDepositFee: [],

            erc20Abi: ERC20,
            MultiCallAbi: MultiCallAbi,
            lpTokenAbi: lpToken,

            wrongNetwork: false,

            whoHasReferredMe: '0x0',
            referredCount: 0,

            currentBlock: 0,
            bnbPrice: 0,
        }

        this.getContractsDataAndAdress();
        this.getTokenContractsDataAndAdress();
        this.getTokenAdditionalInfo();

        this.getAuthUserData();

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    updatePageTitle() {
        document.title = parseFloat(this.state.ourTokenXlionPrice).toFixed(3).toString() + '$ | ' + parseFloat(this.state.ourSecondTokenPrice).toFixed(3).toString() + '$ | ' + parseFloat(this.state.ourTokenPrice).toFixed(3).toString() + '$ | ' + this.state.defiName;
    }

    async componentWillMount() {

        //console.log(getBep20Contract.getBep20Contract('aaa'));

        const currentWallet = '0x0';

        this.setState({ currentWallet: currentWallet })
        await this.getBNBPrice();
        await this.usePriceTokenBusdv2();
        await this.usePriceTokenBusdv2MLion();
        await this.usePriceTokenBusdv2XLion();
        await this.refreshPrices();
        await this.refreshPools();
        await this.loadTokenStats();
        await this.loadOurSecondTokenStats();
        //await this.refreshPools();
        //await this.loadPoolsInfo();
        this.loadBlockchainData()
        this.connectWalletConnect()

        //await this.connectWalletConnect()
        //await this.loadWeb3()
        //await this.loadBlockchainData()
    }

    async disconnectWallet() {
        const currentWallet = '0x0';
        /*
        console.log('window.web3');
        console.log(window.web3);
        */
        this.state.web3Modal.clearCachedProvider();
        /*
        console.log('this.state.web3Modal');
        console.log(this.state.web3Modal);
        */

        this.setState({ currentWallet: currentWallet })
        //this.setState({ loading: true })
        await this.connectWalletConnect(true)
    }

    async connectWalletConnect(buttonPressed = false) {
        const providerOptions = {
            // Example with injected providers
            injected: {
                display: {
                    logo: "data:image/svg+xml;utf8;base64,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",
                    name: "Metamask",
                    description: "Connect with the provider in your Browser"
                },
                package: null
            },
            // Example with WalletConnect provider
            walletconnect: {
                display: {
                    //logo: "data:image/gif;base64,INSERT_BASE64_STRING",
                    name: "Wallet Connect",
                    description: "Scan qrcode with your mobile wallet"
                },
                package: WalletConnectProvider,
                options: {
                    rpc: {
                        //56: 'https://bsc-dataseed1.binance.org:443'
                        56: 'https://bsc-dataseed1.ninicoin.io'
                    },
                    //network: 'binance',
                    //chainId: 56,
                    //infuraId: "1rkU0okz51St8R7XGl5zRkUO2DH", // required
                    bridge: 'https://bridge.walletconnect.org',
                    qrcode: true,
                    pollingInterval: 12000,
                }
            }
        };

        const web3Modal = new Web3Modal({
            network: "binance", // optional
            //network: "0x38", // bsc main net
            //network: "0x61", // bsc test net
            //network: "0x61", // bsc test net
            cacheProvider: true, // optional
            providerOptions // required
        });

        await this.setState({
            web3Modal: web3Modal,
        })

        /*
        if(!web3Modal.cachedProvider) {
            web3Modal.clearCachedProvider();
        }
        */

        if (buttonPressed) {
            this.state.web3Modal.clearCachedProvider();
        }

        const provider = await this.state.web3Modal.connect();
        //const provider = await web3Modal.connect();

        /*
        console.log('provider');
        console.log(provider);
        */
        await this.setState({ provider: provider })

        /*
        console.log('window.ethereum')
        console.log(window.ethereum)
        console.log('window.web3')
        console.log(window.web3)
        */

        //const web3 = new Web3(this.state.provider);

        window.web3 = new Web3(this.state.provider)

        /*
        if (window.ethereum) {
            window.web3 = new Web3(window.ethereum)
            await window.ethereum.enable();
        } else if (window.web3) {
            //window.web3 = new Web3(window.web3.currentProvider)
            window.web3 = new Web3(this.state.provider)
        } else {
            window.alert('Non-Ethereum browser detected. You should consider trying Metamask!')
        }
        */
        const accounts = await window.web3.eth.getAccounts();
        /*
        console.log('this.state.provider');
        console.log(this.state.provider);
        */
        let chainId = this.state.provider.chainId;

        //0x38 - BSC MAIN
        //0x61 - BSC TESTNET

        /*
        console.log('chainId');
        console.log(chainId);
        */

        let currentWallet = '';

        if (chainId == networkId) {
            chainId = networkIdHex;
        }


        if (chainId != networkIdHex) {
            this.setState({
                wrongNetwork: true,
            })
        }

        if (accounts.length > 0 && typeof accounts != 'undefined' && chainId == networkIdHex) {
            /*
            console.log('accounts');
            console.log(accounts);
            */
            currentWallet = accounts[0];
            this.setState({ currentWallet: currentWallet })
        } else {
            currentWallet = '0x0';
            this.setState({ currentWallet: currentWallet })
            //this.setState({ loading: true })
        }

        /*
        console.log('currentWallet');
        console.log(currentWallet);
        */
        /*
        const MasterChefContract = new window.web3.eth.Contract(MasterChef.abi, MasterChefAddress)
        const MasterChefMegaLionContract = new window.web3.eth.Contract(MasterChefMegaLion.abi, MasterChefMegaLionAddress)
        const WBNBPoolContract = new window.web3.eth.Contract(WBNBPool.abi, WBNBPoolAddress)
        const SlionTokenContract = new window.web3.eth.Contract(SlionToken.abi, SlionTokenAddress)
        const MlionTokenContract = new window.web3.eth.Contract(MlionToken.abi, MlionTokenAddress)

        //this.state.MasterChefContract.methods.poolInfo(index).call()

        this.setState({
            MasterChefData: MasterChefData,
            MasterChefContract: MasterChefContract,

            MasterChefMegaLionData: MasterChefMegaLionData,
            MasterChefMegaLionContract: MasterChefMegaLionContract,

            WBNBPoolData: WBNBPoolData,
            WBNBPoolContract: WBNBPoolContract,

            SlionTokenData: SlionTokenData,
            SlionTokenContract: SlionTokenContract,

            MlionTokenData: MlionTokenData,
            MlionTokenContract: MlionTokenContract,
        });
         */

        this.getContractsDataAndAdress();

        if (currentWallet === '0x0') {
            return;
        }

        this.state.provider.on("accountsChanged", (accounts) => {
            if (accounts.length > 0) {
                const currentWallet = accounts[0];
                this.setState({ currentWallet: currentWallet })
            } else {
                const currentWallet = '0x0';
                this.setState({ currentWallet: currentWallet })
                this.setState({ loading: true })
            }
        });

        // Subscribe to chainId change
        this.state.provider.on("chainChanged", (chainId) => {
            if (chainId == networkIdHex) {
                const currentWallet = this.state.provider.selectedAddress;
                this.setState({
                    currentWallet: currentWallet,
                    wrongNetwork: false,
                })
            } else {
                const currentWallet = '0x0';
                this.setState({
                    currentWallet: currentWallet,
                    wrongNetwork: true,
                })
            }

            document.location.reload();
        });

        // Subscribe to session connection
        this.state.provider.on("connect", () => {
            //console.log("connect");
        });

        // Subscribe to session disconnection
        this.state.provider.on("disconnect", (code, reason) => {
            /*
            console.log('disconnect');
            console.log(code, reason);
            */

            const currentWallet = '0x0';
            this.setState({ currentWallet: currentWallet })
            this.setState({ loading: true })
        });

        //await this.loadWeb3()
        //await this.loadBlockchainData()
    }

    async loadBlockchainData() {
        this.setState({ loading: false })
        this.getBNBPrice();
        this.usePriceTokenBusdv2();
        this.usePriceTokenBusdv2MLion();
        this.usePriceTokenBusdv2XLion();
        this.refreshPrices();
        await this.loadPoolsInfo();
        this.loadPoolsUserData();
        this.loadReferralUserData();
        this.loadTokenStats();
        this.loadOurSecondTokenStats();
        this.loadMasterChefStats();
        this.refreshData();
    }

    refreshData = () => {
        setTimeout(() => {
            this.loadBlockchainData();
        }, 10000);
    }

    async loadWeb3() {
        if (window.ethereum) {
            window.web3 = new Web3(window.ethereum)
            await window.ethereum.enable();
        } else if (window.web3) {
            window.web3 = new Web3(window.web3.currentProvider)
        } else {
            window.alert('Non-Ethereum browser detected. You should consider trying Metamask!')
        }
    }

    networkSetup() {
        return new Promise((resolve, reject) => {
            const provider = window.ethereum;

            if (provider) {
                provider
                    .request({
                        method: 'wallet_addEthereumChain',
                        params: [{
                            chainId: `0x${parseInt(56, 10).toString(16)}`,
                            chainName: 'BSC Mainnet',
                            nativeCurrency: {
                                name: 'Binance Coin',
                                symbol: 'BNB',
                                decimals: 18,
                            },
                            rpcUrls: ['https://bsc-dataseed.binance.org'],
                            blockExplorerUrls: ['https://bscscan.com/'],
                        }],
                    })
            } else {
                reject(new Error(`window.ethereum is '${typeof provider}'`));
            }
        });
    }

    registerTokenMetamask() {
        console.log('registerTokenMetamask');
        const tokenAddress = '0xd00981105e61274c8a5cd5a88fe7e037d935b513';
        const tokenSymbol = 'TUT';
        const tokenDecimals = 18;
        const tokenImage = 'http://placekitten.com/200/300';

        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const provider = window.ethereum;
            const wasAdded = provider.request({
                method: 'wallet_watchAsset',
                params: {
                    type: 'ERC20', // Initially only supports ERC20, but eventually more!
                    options: {
                        address: tokenAddress, // The address that the token is at.
                        symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
                        decimals: tokenDecimals, // The number of decimals in the token
                        image: tokenImage, // A string url of the token logo
                    },
                },
            });
        } catch (error) {
            console.log(error);
        }
    }

    async getTokenPricesOwnByBUSDLP(lpContractAddress, tokenAddress) {

        let TokenContract = await this.getContractByTypeAndAddress('token', tokenAddress);
        let BusdContract = await this.getContractByTypeAndAddress('token', '0xe9e7cea3dedca5984780bafc599bd69add087d56');

        let TokenBalanceInLP = await TokenContract.methods.balanceOf(lpContractAddress).call();
        let BusdBalanceInLP = await BusdContract.methods.balanceOf(lpContractAddress).call();

        let BusdPerToken = BusdBalanceInLP / TokenBalanceInLP;

        return BusdPerToken;

    }

    async refreshPrices() {

        let tokenPrices = [];
        let token = null;

        //WBNB
        token = {
            tokenContract: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
            lpContract: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
            name: 'WBNB',
            price: 0,
        }
        tokenPrices.push(token);

        //BTCB
        token = {
            tokenContract: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
            lpContract: '0xF45cd219aEF8618A92BAa7aD848364a158a24F33',
            name: 'BTCB',
            price: 0,
        }
        tokenPrices.push(token);

        //CAKE
        token = {
            tokenContract: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
            lpContract: '0x804678fa97d91B974ec2af3c843270886528a9E6',
            name: 'CAKE',
            price: 0,
        }
        tokenPrices.push(token);

        //ETH
        token = {
            tokenContract: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
            lpContract: '0x7213a321F1855CF1779f42c0CD85d3D95291D34C',
            name: 'ETH',
            price: 0,
        }
        tokenPrices.push(token);

        //DOT
        token = {
            tokenContract: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
            lpContract: '0x9fDaaB9312084298d210B8789629D3054230e998',
            name: 'DOT',
            price: 0,
        }
        tokenPrices.push(token);

        //ADA
        token = {
            tokenContract: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
            lpContract: '0x1E249DF2F58cBef7EAc2b0EE35964ED8311D5623',
            name: 'ADA',
            price: 0,
        }
        tokenPrices.push(token);

        //DAI
        token = {
            tokenContract: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
            lpContract: '0x66FDB2eCCfB58cF098eaa419e5EfDe841368e489',
            name: 'DAI',
            price: 0,
        }
        tokenPrices.push(token);

        //USDT
        token = {
            tokenContract: '0x55d398326f99059ff775485246999027b3197955',
            lpContract: '0x7EFaEf62fDdCCa950418312c6C91Aef321375A00',
            name: 'USDT',
            price: 0,
        }
        tokenPrices.push(token);

        //USDC
        token = {
            tokenContract: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
            lpContract: '0x2354ef4DF11afacb85a5C7f98B624072ECcddbB1',
            name: 'USDC',
            price: 0,
        }
        tokenPrices.push(token);

        //UNI
        token = {
            tokenContract: '0xbf5140a22578168fd562dccf235e5d43a02ce9b1',
            lpContract: '0x0E91275Aec7473105c8509BC41AE54b8FE8a7Fc3',
            name: 'UNI',
            price: 0,
        }
        tokenPrices.push(token);


        let tokenPricesState = [];

        let tokenPrice = null;

        if (networkId == 97) {
            for (var i = 0; i < tokenPrices.length; i += 1) {
                token = tokenPrices[i];
                token.price = 1;
                tokenPricesState[token.tokenContract.toLowerCase()] = token;
            }
        } else {

            let tokensInLPCall = [];
            for (var i = 0; i < tokenPrices.length; i += 1) {
                token = tokenPrices[i];

                tokensInLPCall.push({
                    address: token.tokenContract,
                    name: 'balanceOf',
                    params: [token.lpContract],
                })

                tokensInLPCall.push({
                    address: '0xe9e7cea3dedca5984780bafc599bd69add087d56', //BUSD TOKEN
                    name: 'balanceOf',
                    params: [token.lpContract],
                })

            }

            let tokensInLPCallResult = await this.multicall(this.state.erc20Abi, tokensInLPCall);

            let pointerToken = 0;
            let pointerBusd = 1;

            let TokenBalanceInLP = 0;
            let BusdBalanceInLP = 0;

            let BusdPerToken = 0;

            for (var i = 0; i < tokenPrices.length; i += 1) {
                token = tokenPrices[i];

                if (
                    tokensInLPCallResult.hasOwnProperty(pointerToken)
                    &&
                    tokensInLPCallResult.hasOwnProperty(pointerBusd)
                ) {

                    TokenBalanceInLP = tokensInLPCallResult[pointerToken];
                    BusdBalanceInLP = tokensInLPCallResult[pointerBusd];

                    BusdPerToken = BusdBalanceInLP / TokenBalanceInLP;

                    token.price = BusdPerToken;
                    tokenPricesState[token.tokenContract.toLowerCase()] = token;

                } else {
                    //alert('ooops ' + i + ' - ' + pointerToken + ' - ' + pointerBusd);
                }

                pointerToken += 2;
                pointerBusd += 2;
            }

        }

        this.setState({
            tokenPrices: tokenPricesState
        })

    }

    refreshPools = () => {

        let poolsUrl = '';

        if (networkId == 97) {
            poolsUrl = '/cryptogirl.json';
        }

        poolsUrl = '/cryptogirl.json';

        fetch(poolsUrl)
            .then(response => response.json())
            .then((jsonData) => {

                this.setState({
                    'pools': jsonData
                });


                let poolsDepositToken = [];
                for (const [index, value] of jsonData.entries()) {
                    let type = 'token';

                    let poolName = value.token1Name;

                    if (value.token2Name) {
                        poolName += '-' + value.token2Name;
                        type = 'lp';
                    }

                    poolsDepositToken[value.masterchef + '-' + value.pid] = {
                        depositToken: value.lpToken,
                        type: type,
                        symbol: poolName,
                    }
                }

                this.setState({
                    'poolsDepositToken': poolsDepositToken
                });

                //this.loadPoolsInfo();

            })
            .catch((error) => {
                console.error(error)
            })
    }

    getMulticallAddress() {

        if (networkId == 56) {
            return '0x1ee38d535d541c55c9dae27b12edf090c608e6fb';
        } else {
            return '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412';
        }

    }

    async multicall(abi, calls) {
        const web3 = window.web3;

        const multi = new web3.eth.Contract(MultiCallAbi, this.getMulticallAddress())
        const itf = new Interface(abi)

        const calldata = calls.map((call) => [call.address.toLowerCase(), itf.encodeFunctionData(call.name, call.params)])
        const { returnData } = await multi.methods.aggregate(calldata).call()
        const res = returnData.map((call, i) => itf.decodeFunctionResult(calls[i].name, call))

        return res;
    }


    async loadPoolsInfo() {

        await this.getTotalAllocPointAndCurrentBlockFromBlockChain()
        let poolsUrl = '';

        if (networkId == 97) {
            poolsUrl = '/cryptogirl.json';
        }

        poolsUrl = '/cryptogirl.json';

        fetch(poolsUrl)
                .then(response => response.json())
                .then(async (jsonData) => {
                    // jsonData is parsed json object received from url

                    //let pools = [];
                    let pools = jsonData;
                    if (this.state.pools) {
                        pools = this.state.pools;
                    }

                    /*
                    let dateA = new Date();
                    console.log('aaa1');
                    */

                    let poolInfoSingleCall = [];
                    let totalSupplyCall = [];
                    let lpStakedInMasterChefCall = [];
                    let totalTokensInLPCall = [];

                    for (const [index, value] of jsonData.entries()) {

                        let masterChefAddress = this.getMasterChefAddressByNum(value.masterchef);

                        poolInfoSingleCall.push({
                            address: this.getMasterChefAddressByNum(value.masterchef),
                            name: 'poolInfo',
                            params: [value.pid],
                        })

                        totalSupplyCall.push({
                            address: value.lpToken,
                            name: 'totalSupply',
                        })

                        lpStakedInMasterChefCall.push({
                            address: value.lpToken,
                            name: 'balanceOf',
                            params: [masterChefAddress],
                        })

                        if (value.token2Contract) {

                            totalTokensInLPCall.push({
                                address: value.token1Contract,
                                name: 'balanceOf',
                                params: [value.lpToken],
                            })

                            totalTokensInLPCall.push({
                                address: value.token2Contract,
                                name: 'balanceOf',
                                params: [value.lpToken],
                            })

                        }
                    }

                    let poolInfoSingleResult = await this.multicall(MasterChef.abi, poolInfoSingleCall);
                    let totalSupplyResult = await this.multicall(this.state.erc20Abi, totalSupplyCall);
                    let lpStakedInMasterChefResult = await this.multicall(this.state.erc20Abi, lpStakedInMasterChefCall);
                    let totalTokensInLPResult = await this.multicall(this.state.erc20Abi, totalTokensInLPCall);

                    /*
                    console.log('poolInfoSingleResult');
                    console.log(poolInfoSingleResult);
                    */

                    /*
                    console.log('totalSupplyResult');
                    console.log(totalSupplyResult);
                    */

                    /*
                    console.log('lpStakedInMasterChefResult');
                    console.log(lpStakedInMasterChefResult);
                    */

                    /*
                    console.log('totalTokensInLPResult');
                    console.log(totalTokensInLPResult);
                    */

                    let iTotalTokens1InLP = 0;
                    let iTotalTokens2InLP = 1;
                    for (const [index, value] of jsonData.entries()) {

                        //let poolInfoSingle = await this.getPoolInfoSingleByMasterchefNum(value.masterchef, value.pid);
                        //let poolInfoSingle = poolInfoSingleResult[index].reduce((a, v) => ({ ...a, [v]: v}), {});
                        let poolInfoSingleArray = poolInfoSingleResult[index];
                        let poolInfoSingle = {
                            accXlionPerShare: poolInfoSingleArray['accSlionPerShare'].toLocaleString(),
                            allocPoint: poolInfoSingleArray['allocPoint'].toLocaleString(),
                            depositFeeBP: poolInfoSingleArray['depositFeeBP'].toLocaleString(),
                            lastRewardBlock: poolInfoSingleArray['lastRewardBlock'].toLocaleString(),
                            lpToken: poolInfoSingleArray['lpToken']
                        };

                        let lpContract = this.getContractByTypeAndAddress('token', value.lpToken);
                        let masterChefAddress = this.getMasterChefAddressByNum(value.masterchef);

                        let lpStakedInMasterChef = '';

                        //let totalSupply = await lpContract.methods.totalSupply().call();
                        let totalSupply = totalSupplyResult[index].toLocaleString();


                        //lpStakedInMasterChef = await lpContract.methods.balanceOf(masterChefAddress).call();
                        lpStakedInMasterChef = lpStakedInMasterChefResult[index].toLocaleString();

                        let totalSupplyEth = window.web3.utils.fromWei(totalSupply.toString(), 'Ether')

                        let lpPrice = 0


                        this.state.poolsDepositFee[value.masterchef + '-' + value.pid] = poolInfoSingle.depositFeeBP / 100;

                        if (value.token2Contract) {


                            //let token1Contract = this.getContractByTypeAndAddress('token', value.token1Contract);
                            //let token2Contract = this.getContractByTypeAndAddress('token', value.token2Contract);

                            //let totalTokens1InLP = await token1Contract.methods.balanceOf(value.lpToken).call();
                            let totalTokens1InLP = totalTokensInLPResult[iTotalTokens1InLP].toLocaleString();
                            let totalTokens1InLPEth = window.web3.utils.fromWei(totalTokens1InLP.toString(), 'Ether')


                            //let totalTokens2InLP = await token2Contract.methods.balanceOf(value.lpToken).call();
                            let totalTokens2InLP = totalTokensInLPResult[iTotalTokens2InLP].toLocaleString();
                            let totalTokens2InLPEth = window.web3.utils.fromWei(totalTokens2InLP.toString(), 'Ether')

                            let token1PriceInUSD = this.getTokenPriceByContract(value.token1Contract);
                            let token2PriceInUSD = this.getTokenPriceByContract(value.token2Contract);

                            let totalUSDToken1InLp = totalTokens1InLPEth * token1PriceInUSD;
                            let totalUSDToken2InLp = totalTokens2InLPEth * token2PriceInUSD;

                            let totalUSD = totalUSDToken1InLp + totalUSDToken2InLp;

                            lpPrice = totalUSD / totalSupplyEth;
                            poolInfoSingle.lpPrice = lpPrice;

                            this.state.pairsPrices[value.lpToken.toLowerCase()] = lpPrice;

                            iTotalTokens1InLP = iTotalTokens1InLP + 2;
                            iTotalTokens2InLP = iTotalTokens2InLP + 2;

                        } else {
                            lpPrice = this.getTokenPriceByContract(value.lpToken);
                            poolInfoSingle.lpPrice = lpPrice;
                        }

                        let lpStakedInMasterChefEth = window.web3.utils.fromWei(lpStakedInMasterChef.toString(), 'Ether')
                        poolInfoSingle.tokensBalance = lpStakedInMasterChefEth;

                        let totalLiquidity = lpStakedInMasterChefEth * lpPrice;
                        poolInfoSingle.tokensBalanceInBusd = totalLiquidity;

                        if (value.masterchef == 2) {
                            poolInfoSingle.startBlock = await this.state.WBNBPoolContract.methods.startBlock().call();
                            poolInfoSingle.bonusEndBlock = await this.state.WBNBPoolContract.methods.bonusEndBlock().call();
                        }

                        let newSinglePoolData = {...value, ...poolInfoSingle }
                        pools[index] = newSinglePoolData;


                        this.setState({
                            pools: pools
                        });

                        this.setState({
                            ['poolInfoSinglePid' + value.masterchef + '-' + value.pid]: poolInfoSingle
                        });

                    }

                    this.calculateTVL();
                    /*
                    let dateB = new Date();
                    console.log('aaa2');
                    console.log((dateB - dateA) / 1000);
                    */


                })
                .catch((error) => {
                    console.error(error)
                })

    }

    async getBNBPrice() {

        let bnbContractAddress = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';

        if (networkId == 97) {

            this.setState({
                bnbPrice: 300
            })

            let tokenPrices = this.state.tokenPrices;


            tokenPrices[bnbContractAddress] = {
                'price': 300,
                'symbol': 'WBNB',
            }

            this.setState({
                'tokenPrices': tokenPrices
            });

        } else {


            const lpContractAddress = '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16';
            let BNBContract = this.getContractByTypeAndAddress('token', bnbContractAddress);
            let BusdContract = this.getContractByTypeAndAddress('token', '0xe9e7cea3dedca5984780bafc599bd69add087d56');

            let BNBBalanceInLP = await BNBContract.methods.balanceOf(lpContractAddress).call();
            let BusdBalanceInLP = await BusdContract.methods.balanceOf(lpContractAddress).call();

            let BusdPerBNB = BusdBalanceInLP / BNBBalanceInLP;

            this.setState({
                bnbPrice: BusdPerBNB
            })

            let tokenPrices = this.state.tokenPrices;

            tokenPrices[bnbContractAddress] = {
                'price': BusdPerBNB,
                'symbol': 'WBNB',
            }

            this.setState({
                'tokenPrices': tokenPrices
            });

        }


        this.updatePageTitle();
    }

    async usePriceTokenBusdv2() {

        if (networkId == 97) {

            this.setState({
                ourTokenPrice: 0.05
            })

        } else {

            const lpContractAddress = '0x67f915f44F67b748586e248A187169a866427DA0';
            let SlionContract = await this.getContractByTypeAndAddress('token', '0xb9fcb5b2935d57a8568b6309b3093200482c448d');
            let BusdContract = await this.getContractByTypeAndAddress('token', '0xe9e7cea3dedca5984780bafc599bd69add087d56');

            let SlionBalanceInLP = await SlionContract.methods.balanceOf(lpContractAddress).call();
            let BusdBalanceInLP = await BusdContract.methods.balanceOf(lpContractAddress).call();

            let BusdPerSlion = BusdBalanceInLP / SlionBalanceInLP;

            this.setState({
                ourTokenPrice: BusdPerSlion
            })

        }

        this.updatePageTitle();
    }

    async usePriceTokenBusdv2MLion() {

        if (networkId == 97) {

            this.setState({
                ourSecondTokenPrice: 50
            })

        } else {

            const lpContractAddress = '0x2e7ae1906cb1ccff16e769e98224b3a4515c3e80';
            let MlionContract = await this.getContractByTypeAndAddress('token', '0xa4faa13fb2492f5f137669978e3fb62c046adffc');
            let BNBContract = await this.getContractByTypeAndAddress('token', '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c');

            let MlionBalanceInLP = await MlionContract.methods.balanceOf(lpContractAddress).call();
            let BNBBalanceInLP = await BNBContract.methods.balanceOf(lpContractAddress).call();

            let BusdPerMlion = BNBBalanceInLP * this.state.bnbPrice / MlionBalanceInLP;

            this.setState({
                ourSecondTokenPrice: BusdPerMlion
            })

        }



        this.updatePageTitle();
    }

    async usePriceTokenBusdv2XLion() {


        if (networkId == 97) {

            this.setState({
                ourTokenXlionPrice: 120
            })

        } else {

            const lpContractAddress = '0xb5448edad714217590c268b6bcb5e9baef31978d';
            let XlionContract = await this.getContractByTypeAndAddress('token', '0x2178c3f969923da490154290ac81d93ab1f36863');
            let BusdContract = await this.getContractByTypeAndAddress('token', '0xe9e7cea3dedca5984780bafc599bd69add087d56');

            let XlionBalanceInLP = await XlionContract.methods.balanceOf(lpContractAddress).call();
            let BusdBalanceInLP = await BusdContract.methods.balanceOf(lpContractAddress).call();

            let BusdPerSlion = BusdBalanceInLP / XlionBalanceInLP;

            this.setState({
                ourTokenXlionPrice: BusdPerSlion
            })


        }



        this.updatePageTitle();
    }

    async calculateTVL() {
        var tvl = 0;

        for (const [index, value] of this.state.pools.entries()) {
            if (value.tokensBalanceInBusd) {
                let singleLiquidityPoolInBusd = value.tokensBalanceInBusd;
                tvl += singleLiquidityPoolInBusd;
            }
        }

        this.setState({
            'tvl': tvl
        });
    }

    getLiquidityPools = (masterchef, pid) => {
        let dataLiquidityPools = {
            'tokensBalance': 0,
            'tokenSymbol': '',
            'tokensBalanceInBusd': 0,
        };

        if (this.state.hasOwnProperty('poolBalanceSinglePid' + masterchef + '-' + pid)) {
            return this.state['poolBalanceSinglePid' + masterchef + '-' + pid];
        }

        return dataLiquidityPools;
    }

    getPoolInfo = (masterchef, pid) => {
        let userDataPool = {
            'accSlionPerShare': '',
            'allocPoint': '',
            'lastRewardBlock': '',
            'lpToken': '',
            'depositFeeBP': '',
            'tokenAmount': '',
            'quoteTokenAmount': '',
            'lpTotalInQuoteToken': '',
            'tokenPriceVsQuote': '',
            'poolWeight': '',
            'multiplier': '',
        };

        if (this.state.hasOwnProperty('poolInfoSinglePid' + masterchef + '-' + pid)) {
            return this.state['poolInfoSinglePid' + masterchef + '-' + pid];
        }

        return userDataPool;
    }

    async loadPoolsUserData() {

        let walletAddr = this.state.currentWallet;

        if (walletAddr === '0x0') {
            return false;
        }

        /*
        let dateA = new Date();
        console.log('uuu1');
        */

        let masterChefAddress = '';

        let loadPoolsUserCall = [];
        let loadPoolsUserMasterChefCall = [];
        let masterChefPendingTokensCall = [];
        let walletBalanceCall = [];

        for (const [index, value] of this.state.pools.entries()) {
            let masterChefAddress = this.getMasterChefAddressByNum(value.masterchef);
            let masterChefPendingTokensFunctionName = this.getUserPendingTokensFunctionNameByMasterChefNum(value.masterchef);

            loadPoolsUserCall.push({
                address: value.lpToken,
                name: 'allowance',
                params: [
                    walletAddr,
                    masterChefAddress
                ],
            })

            loadPoolsUserMasterChefCall.push({
                address: masterChefAddress,
                name: 'userInfo',
                params: [
                    value.pid,
                    walletAddr
                ],
            })

            /*
            masterChefPendingTokensCall.push({
                address: masterChefAddress,
                name: masterChefPendingTokensFunctionName,
                params: [
                    value.pid,
                    walletAddr
                ],
            })
            */

            walletBalanceCall.push({
                address: value.lpToken,
                name: 'balanceOf',
                params: [
                    walletAddr
                ],
            })

        }

        let loadPoolsUserResult = await this.multicall(this.state.erc20Abi, loadPoolsUserCall);
        let loadPoolsUserMasterChefResult = await this.multicall(MasterChef.abi, loadPoolsUserMasterChefCall);
        let masterChefPendingTokensResult = [];
        let walletBalanceResult = await this.multicall(this.state.erc20Abi, walletBalanceCall);

        let iCurrentAllowance = 0;
        let iLoadPoolsUser = 0;
        let iGetUserPendingTokens = 0;
        let iWalletBalanceResult = 0;
        let a = '';

        for (const [index, value] of this.state.pools.entries()) {
            let type = 'token';
            if (value.token2Name) {
                type = 'lp';
            }

            if (this.state.currentWallet === '0x0') {
                break;
            }

            //this.hasApprovedContract(value.masterchef, value.pid, type, value.lpToken);
            const currentAllowance = new BigNumber(loadPoolsUserResult[iCurrentAllowance]);

            //this.getUserInfo(value.masterchef, value.pid, this.state.currentWallet);
            let amount = 0;
            let userInfo = loadPoolsUserMasterChefResult[iLoadPoolsUser];
            if (userInfo.hasOwnProperty('amount')) {
                amount = userInfo.amount.toString();
            }

            //TODO!!!!
            //a = await this.getUserPendingTokens(value.masterchef, value.pid, this.state.currentWallet);
            this.getUserPendingTokens(value.masterchef, value.pid, this.state.currentWallet);
            /*
            let rewardPendingTokens = loadPoolsUserMasterChefResult[iGetUserPendingTokens];
            console.log('.....');
            console.log(a);
            console.log(rewardPendingTokens);
            */

            //this.getUserWalletBalance(value.masterchef, value.pid, type, value.lpToken, this.state.currentWallet);
            let walletBalance = 0;
            walletBalance = walletBalanceResult[iWalletBalanceResult].toString();

            this.setState({
                ['ApprovedPid' + value.masterchef + '-' + value.pid]: currentAllowance.toString(),
                ['UserInfoPid' + value.masterchef + '-' + value.pid]: {
                    stakedAmount: amount,
                },
                //['RewardPendingTokensPid' + value.masterchef + '-' + value.pid]: rewardPendingTokens
                ['UserWalletBalancePid' + value.masterchef + '-' + value.pid]: walletBalance
            });

            iCurrentAllowance = iCurrentAllowance + 1;
            iLoadPoolsUser = iLoadPoolsUser + 1;
            iGetUserPendingTokens = iGetUserPendingTokens + 1;
            iWalletBalanceResult = iWalletBalanceResult + 1;
        }

        /*
        let dateB = new Date();
        console.log('uuu2');
        console.log((dateB - dateA) / 1000);
        */
    }

    async loadReferralUserData() {
        if (this.state.currentWallet == '0x0') {
            return false;
        }

        const whoHasReferredMe = await this.state.MasterChefXlionContract.methods.referrers(this.state.currentWallet).call()

        const referredCount = await this.state.MasterChefXlionContract.methods.referredCount(this.state.currentWallet).call()

        this.setState({
            whoHasReferredMe: whoHasReferredMe,
            referredCount: referredCount,
        })
    }

    async loadTokenStats() {
        const tokenContract = this.getContractByTypeAndAddress('token', this.state.ourTokenContract);

        let callsTokenStats = [
            // totalBurned
            {
                address: this.state.ourTokenContract,
                name: 'balanceOf',
                params: ['0x000000000000000000000000000000000000dEaD'],
            },
            //tokenTotalSupply
            {
                address: this.state.ourTokenContract,
                name: 'totalSupply',
            }
        ];


        if (this.state.currentWallet != '0x0') {
            callsTokenStats.push({
                address: this.state.ourTokenContract,
                name: 'balanceOf',
                params: [this.state.currentWallet],
            });
        }

        let [
            totalBurned,
            tokenTotalSupply,
            tokensInYourWallet,
        ] = await this.multicall(this.state.erc20Abi, callsTokenStats);

        if (typeof tokensInYourWallet == 'undefined') {
            tokensInYourWallet = 0;
        }


        let totalBurnedEther = window.web3.utils.fromWei(totalBurned.toString(), 'Ether')
        let tokenTotalSupplyEther = window.web3.utils.fromWei(tokenTotalSupply.toString(), 'Ether')
        let tokenPriceInBusd = this.getTokenPriceByContract(tokenContract._address);

        let tokensInYourWalletEther = window.web3.utils.fromWei(tokensInYourWallet.toString(), 'Ether')
        tokenTotalSupplyEther = tokenTotalSupplyEther - totalBurnedEther;

        this.setState({
            tokenTotalSupply: tokenTotalSupplyEther,
            tokenTotalInCirculation: 1000,
            marketCap: tokenTotalSupplyEther * tokenPriceInBusd,
            totalTokenBurned: totalBurnedEther,
            tokensInYourWallet: tokensInYourWalletEther,
        })
    }

    async loadOurSecondTokenStats() {
        const tokenContract = this.getContractByTypeAndAddress('token', this.state.ourSecondTokenContract);


        let callsTokenStats = [
            // totalBurned
            {
                address: this.state.ourSecondTokenContract,
                name: 'balanceOf',
                params: ['0x000000000000000000000000000000000000dEaD'],
            },
            //tokenTotalSupply
            {
                address: this.state.ourSecondTokenContract,
                name: 'totalSupply',
            }
        ];


        if (this.state.currentWallet != '0x0') {
            callsTokenStats.push({
                address: this.state.ourSecondTokenContract,
                name: 'balanceOf',
                params: [this.state.currentWallet],
            });
        }

        let [
            totalBurned,
            tokenTotalSupply,
            tokensInYourWallet,
        ] = await this.multicall(this.state.erc20Abi, callsTokenStats);

        if (typeof tokensInYourWallet == 'undefined') {
            tokensInYourWallet = 0;
        }

        let totalBurnedEther = window.web3.utils.fromWei(totalBurned.toString(), 'Ether')

        let tokenTotalSupplyEther = window.web3.utils.fromWei(tokenTotalSupply.toString(), 'Ether')
        let tokenPriceInBusd = this.getTokenPriceByContract(tokenContract._address);


        let tokensInYourWalletEther = window.web3.utils.fromWei(tokensInYourWallet.toString(), 'Ether')
        tokenTotalSupplyEther = tokenTotalSupplyEther - totalBurnedEther;

        this.setState({
            ourSecondTokenTotalSupply: tokenTotalSupplyEther,
            ourSecondTokenTotalInCirculation: 200,
            ourSecondTokenMarketCap: tokenTotalSupplyEther * tokenPriceInBusd,
            totalSecondTokenBurned: totalBurnedEther,
            secondTokenTokensInYourWallet: tokensInYourWalletEther,
        })
    }

    async hasApprovedContract(masterchef, pid, type, tokenAddress) {
        if (this.state.currentWallet === '0x0') {
            return false;
        }

        let masterChefAddress = this.getMasterChefAddressByNum(masterchef);

        const contract = this.getContractByTypeAndAddress(type, tokenAddress);

        if (this.state.currentWallet && masterChefAddress) {
            const hasApproved = await contract.methods.allowance(this.state.currentWallet, masterChefAddress).call();
            const currentAllowance = new BigNumber(hasApproved);


            this.setState({
                ['ApprovedPid' + masterchef + '-' + pid]: currentAllowance.toString()
            });

            return currentAllowance;
        } else {
            return false;
        }
    }

    async getUserInfo(masterchef, pid, account) {
        if (account === '0x0') {
            return false;
        }

        //let masterchefContract = this.getMasterChefContractByNum(masterchef);

        let userInfo = await this.getUserInfoByMasterChefNum(masterchef, account, pid);

        let amount = 0;

        if (userInfo.hasOwnProperty('amount')) {
            amount = userInfo.amount;
        }

        this.setState({
            ['UserInfoPid' + masterchef + '-' + pid]: {
                stakedAmount: amount,
            }
        });
    }

    async getUserPendingTokens(masterchef, pid, account) {
        if (account === '0x0') {
            return false;
        }

        let rewardPendingTokens = await this.getUserPendingTokensByMasterChefNum(masterchef, account, pid);

        this.setState({
            ['RewardPendingTokensPid' + masterchef + '-' + pid]: rewardPendingTokens
        });

        return rewardPendingTokens;
    }

    async getUserWalletBalance(masterchef, pid, type, tokenAddress, account) {
        if (account === '0x0') {
            return false;
        }

        const contract = this.getContractByTypeAndAddress(type, tokenAddress);

        let walletBalance = await contract.methods.balanceOf(account).call()

        this.setState({
            ['UserWalletBalancePid' + masterchef + '-' + pid]: walletBalance
        });

        return walletBalance;
    }

    getDataUserPool = (masterchef, pid) => {

        let userDataPool = {
            'approvedQty': '0',
            'stakedAmount': '0',
            'rewardDebt': '0',
        };

        if (this.state.hasOwnProperty('ApprovedPid' + masterchef + '-' + pid)) {
            userDataPool.approvedQty = this.state['ApprovedPid' + masterchef + '-' + pid];
        }

        if (this.state.hasOwnProperty('UserInfoPid' + masterchef + '-' + pid)) {
            let userInfoPid = this.state['UserInfoPid' + masterchef + '-' + pid];

            if (userInfoPid.hasOwnProperty('stakedAmount')) {
                userDataPool.stakedAmount = userInfoPid.stakedAmount;
            }
        }

        if (this.state.hasOwnProperty('RewardPendingTokensPid' + masterchef + '-' + pid)) {
            userDataPool.rewardDebt = this.state['RewardPendingTokensPid' + masterchef + '-' + pid];
        }

        return userDataPool;
    }

    getDataUserBalance = (masterchef, pid) => {
        let userWalletBalancePid = 0;

        if (this.state.hasOwnProperty('UserWalletBalancePid' + masterchef + '-'  + pid)) {
            userWalletBalancePid = this.state['UserWalletBalancePid' + masterchef + '-'  + pid];
        }

        return userWalletBalancePid;
    }

    getTokenPriceBySymbol = (symbol) => {
        /*
        if (this.state.hasOwnProperty('prices')) {
            if (this.state.prices.hasOwnProperty('prices')) {
                if (this.state.prices.prices.hasOwnProperty(symbol)) {
                    return this.state.prices.prices[symbol];
                } else {
                    return this.state.prices.prices['WBNB'];
                }
            }
        }
        */
        return false;
    }

    getTokenPriceByContract = (contract) => {
        contract = contract.toLowerCase();

        let tokenPriceSpecial = this.getTokenPriceSpecial(contract);

        if (tokenPriceSpecial !== null) {
            return tokenPriceSpecial;
        }

        if (this.state.hasOwnProperty('tokenPrices')) {
            if (this.state.tokenPrices.hasOwnProperty(contract)) {
                return this.state.tokenPrices[contract].price;
            } else {
                return 1;
            }
        }
        return false;
    }

    getPairPriceByContract = (contract) => {
        contract = contract.toLowerCase();
        if (this.state.hasOwnProperty('pairsPrices')) {
            if (this.state.pairsPrices.hasOwnProperty(contract)) {
                return this.state.pairsPrices[contract];
            } else {
                return 1;
            }
        }
        return false;
    }

    getPoolApy = (
        stakingTokenPrice,
        rewardTokenPrice,
        totalStaked,
        tokenPerBlock,
    ) => {
        const totalRewardPricePerYear = new BigNumber(rewardTokenPrice).times(tokenPerBlock).times(BLOCKS_PER_YEAR)
        const totalStakingTokenInPool = new BigNumber(stakingTokenPrice).times(totalStaked)
        const apy = totalRewardPricePerYear.div(totalStakingTokenInPool).times(100)

        return apy.isNaN() || !apy.isFinite() ? null : apy.toNumber()
    }

    getFarmApy = (poolWeight, cakePriceUsd, poolLiquidityUsd, tokenPerBlock) => {
        const yearlyCakeRewardAllocation = tokenPerBlock.times(BLOCKS_PER_YEAR).times(poolWeight)
        const apy = yearlyCakeRewardAllocation.times(cakePriceUsd).div(poolLiquidityUsd).times(100)

        return apy.isNaN() || !apy.isFinite()  ? null : apy.toNumber()
    }

    getContractByTypeAndAddress = (type, tokenAddress) => {
        const web3 = window.web3;

        let contract = '';

        if (type === 'lp') {
            contract = new web3.eth.Contract(this.state.lpTokenAbi, tokenAddress)
        } else {
            contract = new web3.eth.Contract(this.state.erc20Abi, tokenAddress)
        }

        return contract;
    }

    approveContract = (masterchef, type, tokenAddress) => {
        if (this.state.currentWallet === '0x0') {
            return false;
        }

        //let checkUserUrl = 'http://localhost:8000/api/v1/check-user-login';

        //this.setState({ loading: true })
        const contract = this.getContractByTypeAndAddress(type, tokenAddress);

        //let amount = window.web3.utils.toWei('999999999999999', 'Ether');
        let amount = window.web3.utils.toWei('9999999999999', 'Ether');

        let masterChefAddress = this.getMasterChefAddressByNum(masterchef);

        /*
        console.log('masterchef');
        console.log(masterchef);

        console.log('masterChefAddress');
        console.log(masterChefAddress);
        */

        contract.methods.approve(masterChefAddress, amount).send({
            from: this.state.currentWallet,
            gasLimit: 200000
        }, function (error, hash) {
            /*
            console.log('aaa');

            console.log('callllback!')
            console.log(error);
            console.log(hash);
            */
        }).on('confirmation', function(confirmationNumber, receipt) {

            if (confirmationNumber === 0) {
                if (receipt.status) {
                    notifyOk(receipt.transactionHash)
                } else {
                    notifyNoOk(receipt.transactionHash)
                }
            }
        });

    };

    deposit = (masterchef, pid, amount) => {
        if (this.state.currentWallet === '0x0') {
            return false;
        }

        if (amount <= 0) {
            return false;
        }


        fetch(checkUserUrl, {
            method: 'POST',
            //origin: 'http://authdefi.xtralion.finance',
            credentials: 'include',
        })
            .then(response => response.json())
            .then((jsonData) => {


                if (!jsonData.success && 1 == 2) {

                    let notifyContent = '';

                    if (jsonData.title != '') {
                        notifyContent = <div>
                            <strong>{jsonData.title}</strong> 😲<br />
                            {jsonData.message} <a href={userDashboardURL}>the login page</a>
                        </div>;
                    } else {
                        notifyContent = <div>
                            <strong>You're not online!</strong> 😲<br />
                            You will be redirected to <a href={userDashboardURL}>the login page</a>
                        </div>;
                    }


                    toast.error(notifyContent, {
                        autoClose: 5000,
                    });

                    setTimeout(() => {
                        document.location = userDashboardURL;
                    }, 5000);
                    return false;
                }

                amount = amount.toString();
                amount = window.web3.utils.toWei(amount, 'Ether')


                let depositFunction = this.getDepositMethodMasterChefContractByNum(masterchef, pid, amount);

                let currentWallet = this.state.currentWallet;
                let tokenSymbol = '';
                let depositTokenPrice = 0;
                let poolDepositFee = 0;

                if (masterchef != 3) {

                    let depositToken = this.state.poolsDepositToken[masterchef + '-' + pid];
                    let depositTokenContract = depositToken.depositToken;

                    if (depositToken.type == 'token') {
                        depositTokenPrice = this.getTokenPriceByContract(depositTokenContract);
                    } else {
                        depositTokenPrice = this.getPairPriceByContract(depositTokenContract);
                    }

                    tokenSymbol = depositToken.symbol;

                    poolDepositFee = this.state.poolsDepositFee[masterchef + '-' + pid];
                }

                depositFunction.send({
                    from: this.state.currentWallet,
                    //gasLimit: 200000
                })
                    .on('transactionHash', function(hash){

                        if (masterchef != 3) {
                            let formdata = new FormData();
                            formdata.append('totalAmount', window.web3.utils.fromWei(amount, 'ether'));
                            formdata.append('tokenSymbol', tokenSymbol);
                            formdata.append('tokenPrice', depositTokenPrice);
                            formdata.append('feePercent', poolDepositFee);
                            formdata.append('transactionHash', hash);
                            formdata.append('walletAddress', currentWallet);

                            fetch(saveTransactionUrl, {
                                method: 'POST',
                                credentials: 'include',
                                body: formdata,
                            })
                                .then(response => response.json())
                                .then((dataResponse) => {
                                    console.log(dataResponse);
                                });
                        }

                    })
                    .on('confirmation', function(confirmationNumber, receipt) {

                    if (confirmationNumber === 0) {
                        if (receipt.status) {
                            notifyOk(receipt.transactionHash)
                        } else {
                            notifyNoOk(receipt.transactionHash)
                        }
                    }
                });

            })
            .catch((error) => {
                // handle your errors here
                console.error(error)
            })
    }

    enterStaking = (amount) => {
        if (this.state.currentWallet === '0x0') {
            return false;
        }

        if (amount <= 0) {
            return false;
        }

        amount = amount.toString();
        amount = window.web3.utils.toWei(amount, 'Ether')

        this.state.MasterChefContract.methods.enterStaking(amount).send({
            from: this.state.currentWallet,
            //gasLimit: 2000000
        })
        .on('confirmation', function(confirmationNumber, receipt) {

            if (confirmationNumber === 0) {
                if (receipt.status) {
                    notifyOk(receipt.transactionHash)
                } else {
                    notifyNoOk(receipt.transactionHash)
                }
            }
        }); // If a out of gas error, the second parameter is the receipt.


    }

    leaveStaking = (amount) => {
        if (this.state.currentWallet === '0x0') {
            return false;
        }

        amount = amount.toString();
        amount = window.web3.utils.toWei(amount, 'Ether');

        this.state.MasterChefContract.methods.leaveStaking(amount).send({
            from: this.state.currentWallet,
            //gasLimit: 2000000
        }).on('confirmation', function(confirmationNumber, receipt) {

            if (confirmationNumber === 0) {
                if (receipt.status) {
                    notifyOk(receipt.transactionHash)
                } else {
                    notifyNoOk(receipt.transactionHash)
                }
            }
        });
    }

    withdraw = (masterchef, _pid, amount) => {
        if (this.state.currentWallet === '0x0') {
            return false;
        }

        fetch(checkUserUrl, {
            method: 'POST',
            //origin: 'http://authdefi.xtralion.finance',
            credentials: 'include',
        })
            .then(response => response.json())
            .then((jsonData) => {


                if (!jsonData.success && 1 == 2) {

                    let notifyContent = '';

                    if (jsonData.title != '') {
                        notifyContent = <div>
                            <strong>{jsonData.title}</strong> 😲<br />
                            {jsonData.message} <a href={userDashboardURL}>the login page</a>
                        </div>;
                    } else {
                        notifyContent = <div>
                            <strong>You're not online!</strong> 😲<br />
                            You will be redirected to <a href={userDashboardURL}>the login page</a>
                        </div>;
                    }


                    toast.error(notifyContent, {
                        autoClose: 5000,
                    });

                    setTimeout(() => {
                        document.location = userDashboardURL;
                    }, 5000);
                    return false;
                }

                amount = amount.toString();
                amount = window.web3.utils.toWei(amount, 'Ether');

                let withdrawFunction = this.getWithdrawMethodMasterChefContractByNum(masterchef, _pid, amount);

                //this.setState({ loading: true })
                withdrawFunction.send({
                    from: this.state.currentWallet,
                    //gasLimit: 2000000
                }).on('confirmation', function(confirmationNumber, receipt) {

                    if (confirmationNumber === 0) {
                        if (receipt.status) {
                            notifyOk(receipt.transactionHash)
                        } else {
                            notifyNoOk(receipt.transactionHash)
                        }
                    }
                });

        })
        .catch((error) => {
            // handle your errors here
            console.error(error)
        })
    }

    setAccountModal = (account) => {

        let accountModalContent = [];

        accountModalContent.push(<h2 className="text-center">Your Wallet</h2>);
        accountModalContent.push(<div className="text-center">{account.substring(0,6) + '...' + account.substr(account.length - 4)}</div>);
        accountModalContent.push(
            <div className="modalAccountButtons">
                <a className="viewOnBscScanButton btn btn-block btn-primary" target="_blank" href={'https://bscscan.com/address/' + account}>View on BscScan</a>
                <a className="logoutButton btn btn-block btn-primary" target="_blank" href="" onClick={(event => {
                    event.preventDefault();
                    this.handleCloseModal();
                    this.disconnectWallet();
                })}>Logout</a>
        </div>);

        this.setState({ modalContent: accountModalContent });
    }

    setAprToModal = (apr) => {

        let aprContent = [];

        aprContent.push(
            <h2 className="aprHeader">
                APR<br />
                <small>
                    (not APY)
                </small>
            </h2>
        )

        let oneDayApr = parseFloat(apr) / 365;
        let oneHour = oneDayApr / 24;
        let sevenDaysApr = oneDayApr * 7;
        let thirtyDayApr = oneDayApr * 30;

        aprContent.push(
            <table className="aprTable">
                <thead>
                    <tr>
                        <td className="aprTableTextLeft">TIME</td>
                        <td className="aprTableTextRight">APR</td>
                    </tr>
                </thead>
                <tbody>
                    {/*
                    <tr>
                        <td className="aprTableTextLeft">1h</td>
                        <td className="aprTableTextRight">{parseFloat(oneHour).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                    </tr>
                    */}
                    <tr>
                        <td className="aprTableTextLeft">1d</td>
                        <td className="aprTableTextRight">{parseFloat(oneDayApr).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                    </tr>
                    <tr>
                        <td className="aprTableTextLeft">7d</td>
                        <td className="aprTableTextRight">{parseFloat(sevenDaysApr).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                    </tr>
                    <tr>
                        <td className="aprTableTextLeft">30d</td>
                        <td className="aprTableTextRight">{parseFloat(thirtyDayApr).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                    </tr>
                    <tr>
                        <td className="aprTableTextLeft">365d</td>
                        <td className="aprTableTextRight">{parseFloat(apr).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                    </tr>
                </tbody>
            </table>
        )


        this.setState({ modalContent: aprContent });
    }

    handleOpenModal () {
        this.setState({ showModal: true });
    }

    handleCloseModal () {
        this.setState({ showModal: false });
    }

    handleCloseAlert (e, idAlert) {
        e.preventDefault();
        document.getElementById(idAlert).remove();
    }

    loadCountdown = (callback) => {
        const existingScript = document.getElementById('flipdown');

        setTimeout(() => {
            if (!existingScript) {
                const script = document.createElement('script');
                script.src = '/flipdown.js';
                script.id = 'flipdown';
                document.body.appendChild(script);
                script.onload = () => {
                    if (callback) callback();
                };
            }
        }, 300);

        setTimeout(() => {
            if (!existingScript) {
                const script = document.createElement('script');
                script.src = '/countdown.js?v=3';
                script.id = 'countdown';
                document.body.appendChild(script);
                script.onload = () => {
                    if (callback) callback();
                };
            }
        }, 1000);

        if (existingScript && callback) callback();
    };

    render() {

        let wrongNetworkAlert = '';

        if (this.state.wrongNetwork) {
            this.networkSetup();
            wrongNetworkAlert = <div id="alertWrongNetwork" className="cageAlertDown">
                <div className="cageAlertDownCloseIconContainer">
                    <a href="" onClick={((e) => this.handleCloseAlert(e, 'alertWrongNetwork'))}>✕</a>
                </div>
                <div className="cageAlertDownTextContainer">
                    Use Binance Smart Chain
                </div>
            </div>;
        }

        let noResposability = '';


        return (
            <Router>
                <ScrollToTop>
                    <link href="/joseba.css?v=11" rel="stylesheet" />
                    <div>

                        <Menu
                            ourTokenName={this.state.ourTokenName}
                            ourTokenPrice={this.state.ourTokenPrice}
                            ourTokenContract={this.state.ourTokenContract}

                            ourSecondTokenName={this.state.ourSecondTokenName}
                            ourSecondTokenPrice={this.state.ourSecondTokenPrice}
                            ourSecondTokenContract={this.state.ourSecondTokenContract}

                            ourXlionTokenName={this.state.ourXlionTokenName}
                            ourTokenXlionPrice={this.state.ourTokenXlionPrice}
                            ourXlionTokenContract={this.state.ourXlionTokenContract}

                            account={this.state.currentWallet}
                            connectWalletConnect={this.connectWalletConnect.bind(this)}
                            disconnectWallet={this.disconnectWallet.bind(this)}

                            setAccountModal={this.setAccountModal.bind(this)}

                            handleOpenModal={this.handleOpenModal.bind(this)}

                            defiName={this.state.defiName}

                            userEmail={this.state.userEmail}
                        />

                        {/*
                        <div id="subMenu">
                            <div className="row">
                                <div className="col-5 text-left">

                                </div>
                                <div className="col-7 text-right">
                                    {loginSignInBox}
                                </div>
                            </div>
                        </div>
                        */}


                        <div className="container-fluid mt-5">
                            <div className="row">
                                <main role="main" className="col-12 ml-auto mr-auto">
                                    <div className="content mr-auto ml-auto">
                                        <a
                                            href="/"
                                            rel="noopener noreferrer"
                                        >
                                        </a>

                                        <Switch>
                                            <Route exact path="/">
                                                {/*
                                                <Redirect to="/earn/farms" />
                                                */}
                                                <Home
                                                    defiName={this.state.defiName}

                                                    ourTokenName={this.state.ourTokenName}
                                                    ourTokenPrice={this.state.ourTokenPrice}
                                                    ourTokenContract={this.state.ourTokenContract}
                                                    tokenTotalSupply={this.state.tokenTotalSupply}
                                                    tokenTotalInCirculation={this.state.tokenTotalInCirculation}
                                                    totalTokenBurned={this.state.totalTokenBurned}
                                                    marketCap={this.state.marketCap}
                                                    slionPerBlockEther={this.state.slionPerBlockEther}
                                                    tokensInYourWallet={this.state.tokensInYourWallet}

                                                    ourSecondTokenName={this.state.ourSecondTokenName}
                                                    ourSecondTokenPrice={this.state.ourSecondTokenPrice}
                                                    ourSecondTokenContract={this.state.ourSecondTokenContract}
                                                    ourSecondTokenTotalSupply={this.state.ourSecondTokenTotalSupply}
                                                    ourSecondTokenTotalInCirculation={this.state.ourSecondTokenTotalInCirculation}
                                                    totalSecondTokenBurned={this.state.totalSecondTokenBurned}
                                                    ourSecondTokenMarketCap={this.state.ourSecondTokenMarketCap}
                                                    mlionPerBlockEther={this.state.mlionPerBlockEther}
                                                    secondTokenTokensInYourWallet={this.state.secondTokenTokensInYourWallet}

                                                    ourXlionTokenName={this.state.ourXlionTokenName}
                                                    ourTokenXlionPrice={this.state.ourTokenXlionPrice}
                                                    ourXlionTokenContract={this.state.ourXlionTokenContract}
                                                    ourXlionTokenTotalSupply={this.state.ourXlionTokenTotalSupply}
                                                    totalXlionTokenBurned={this.state.totalXlionTokenBurned}
                                                    ourXlionTokenMarketCap={this.state.ourXlionTokenMarketCap}
                                                    xlionPerBlockEther={this.state.xlionPerBlockEther}
                                                    xlionTokenTokensInYourWallet={this.state.xlionTokenTokensInYourWallet}

                                                    xlionTokentransferTaxRate={this.state.xlionTokentransferTaxRate}
                                                    xlionTokenMaxTransferAmountRate={this.state.xlionTokenMaxTransferAmountRate}
                                                    maxTransferAmountRatePercent={this.state.maxTransferAmountRatePercent}

                                                    tvl={this.state.tvl}

                                                    pools={this.state.pools}

                                                    getDataUserPool={this.getDataUserPool.bind(this)}

                                                    withdraw={this.withdraw.bind(this)}

                                                    registerTokenMetamask={this.registerTokenMetamask.bind(this)}
                                                />

                                            </Route>

                                            <Route path="/earn/:earnTypeSlug" exact>
                                                <Earn
                                                    native="1"

                                                    approveContract={this.approveContract.bind(this)}
                                                    deposit={this.deposit.bind(this)}
                                                    withdraw={this.withdraw.bind(this)}
                                                    connectWalletConnect={this.connectWalletConnect.bind(this)}
                                                    hasApprovedContract={this.hasApprovedContract.bind(this)}

                                                    getDataUserPool={this.getDataUserPool.bind(this)}
                                                    getDataUserBalance={this.getDataUserBalance.bind(this)}
                                                    getPoolInfo={this.getPoolInfo.bind(this)}
                                                    getLiquidityPools={this.getLiquidityPools.bind(this)}
                                                    handleOpenModal={this.handleOpenModal.bind(this)}
                                                    setAprToModal={this.setAprToModal.bind(this)}
                                                    getFarmApy={this.getFarmApy.bind(this)}
                                                    getPoolApy={this.getPoolApy.bind(this)}
                                                    getTokenPriceBySymbol={this.getTokenPriceBySymbol.bind(this)}
                                                    getTokenPriceByContract={this.getTokenPriceByContract.bind(this)}
                                                    getPairPriceByContract={this.getPairPriceByContract.bind(this)}

                                                    getTotalAllocPointByMasterchefNum={this.getTotalAllocPointByMasterchefNum.bind(this)}
                                                    getTokensPerBlockByMasterchefNum={this.getTokensPerBlockByMasterchefNum.bind(this)}
                                                    getRewardTokenPriceByMasterchefNum={this.getRewardTokenPriceByMasterchefNum.bind(this)}
                                                    getEarnTokenNameByMasterchefNum={this.getEarnTokenNameByMasterchefNum.bind(this)}
                                                    getDepositFeeTextByMasterchefNum={this.getDepositFeeTextByMasterchefNum.bind(this)}

                                                    account={this.state.currentWallet}
                                                    ourTokenName={this.state.ourTokenName}
                                                    ourTokenPrice={this.state.ourTokenPrice}
                                                    pools={this.state.pools}
                                                    slionPerBlockEther={this.state.slionPerBlockEther}
                                                    totalAllocPoint={this.state.totalAllocPoint}
                                                    ourSecondTotalAllocPoint={this.state.ourSecondTotalAllocPoint}
                                                    marketCap={this.state.marketCap}

                                                    ourSecondTokenName={this.state.ourSecondTokenName}
                                                    ourSecondTokenPrice={this.state.ourSecondTokenPrice}
                                                    ourSecondTokenContract={this.state.ourSecondTokenContract}
                                                    mlionPerBlockEther={this.state.mlionPerBlockEther}
                                                    ourSecondTokenMarketCap={this.state.ourSecondTokenMarketCap}

                                                    ourXlionTokenName={this.state.ourXlionTokenName}

                                                    currentBlock={this.state.currentBlock}
                                                    bnbPrice={this.state.bnbPrice}

                                                    tvl={this.state.tvl}
                                                />
                                            </Route>

                                            {/*
                                            <Route path="/earn/:poolTypeSlug/:numMasterchef/:pid">
                                                <PoolSingle
                                                    approveContract={this.approveContract.bind(this)}
                                                    deposit={this.deposit.bind(this)}
                                                    withdraw={this.withdraw.bind(this)}
                                                    enterStaking={this.enterStaking.bind(this)}
                                                    leaveStaking={this.leaveStaking.bind(this)}
                                                    connectWalletConnect={this.connectWalletConnect.bind(this)}
                                                    hasApprovedContract={this.hasApprovedContract.bind(this)}

                                                    getDataUserPool={this.getDataUserPool.bind(this)}
                                                    getDataUserBalance={this.getDataUserBalance.bind(this)}
                                                    getPoolInfo={this.getPoolInfo.bind(this)}
                                                    getLiquidityPools={this.getLiquidityPools.bind(this)}

                                                    getFarmApy={this.getFarmApy.bind(this)}
                                                    getPoolApy={this.getPoolApy.bind(this)}
                                                    getTokenPriceBySymbol={this.getTokenPriceBySymbol.bind(this)}
                                                    getTokenPriceByContract={this.getTokenPriceByContract.bind(this)}
                                                    getPairPriceByContract={this.getPairPriceByContract.bind(this)}

                                                    getTotalAllocPointByMasterchefNum={this.getTotalAllocPointByMasterchefNum.bind(this)}
                                                    getTokensPerBlockByMasterchefNum={this.getTokensPerBlockByMasterchefNum.bind(this)}
                                                    getRewardTokenPriceByMasterchefNum={this.getRewardTokenPriceByMasterchefNum.bind(this)}
                                                    getEarnTokenNameByMasterchefNum={this.getEarnTokenNameByMasterchefNum.bind(this)}
                                                    getDepositFeeTextByMasterchefNum={this.getDepositFeeTextByMasterchefNum.bind(this)}

                                                    account={this.state.currentWallet}
                                                    ourTokenName={this.state.ourTokenName}
                                                    ourTokenPrice={this.state.ourTokenPrice}
                                                    pools={this.state.pools}
                                                    slionPerBlockEther={this.state.slionPerBlockEther}
                                                    totalAllocPoint={this.state.totalAllocPoint}
                                                    ourSecondTotalAllocPoint={this.state.ourSecondTotalAllocPoint}

                                                    ourSecondTokenName={this.state.ourSecondTokenName}
                                                    ourSecondTokenPrice={this.state.ourSecondTokenPrice}
                                                    ourSecondTokenContract={this.state.ourSecondTokenContract}
                                                    mlionPerBlockEther={this.state.mlionPerBlockEther}

                                                    ourXlionTokenName={this.state.ourXlionTokenName}

                                                    currentBlock={this.state.currentBlock}
                                                    bnbPrice={this.state.bnbPrice}
                                                />
                                            </Route>
                                            */}

                                            {/*
                                            <Route path="/referral">
                                                <Referral
                                                    connectWalletConnect={this.connectWalletConnect.bind(this)}
                                                    account={this.state.currentWallet}
                                                    ourTokenName={this.state.ourTokenName}
                                                    defiName={this.state.defiName}
                                                    defiUrl={this.state.defiUrl}

                                                    whoHasReferredMe={this.state.whoHasReferredMe}
                                                    referredCount={this.state.referredCount}

                                                    ourXlionTokenName={this.state.ourXlionTokenName}

                                                />
                                            </Route>
                                            */}

                                            <Route path="/audit">
                                                <Audit />
                                            </Route>

                                            <Route path="/the-game" exact>
                                                <Redirect to="/the-game/play" />
                                            </Route>

                                            <Route path="/the-game/nft/:tokenId">
                                                <TheGameNftSingle />
                                            </Route>

                                            <Route path="/the-game/:tab/:param1/:param2/:param3">
                                                <TheGame />
                                            </Route>

                                            <Route path="/the-game/:tab">
                                                <TheGame />
                                            </Route>

                                            <Route path="/whitepaper">
                                                <Whitepaper />
                                            </Route>

                                            <Route path="/login">
                                                <LoginPage
                                                    getAuthUserData={this.getAuthUserData.bind(this)}
                                                />
                                            </Route>

                                            <Route path="/register">
                                                <RegisterPage />
                                            </Route>

                                            <Route path="/kyc">
                                                <KycPage />
                                            </Route>

                                            <Route path="/edit-profile">
                                                <EditProfilePage />
                                            </Route>

                                        </Switch>

                                    </div>
                                </main>
                            </div>
                        </div>

                        <ReactModal
                            key="modalAPR"
                            isOpen={this.state.showModal}
                            contentLabel="Minimal Modal Example"
                            ariaHideApp={false}
                        >
                            <a className="btn-close-modal" href="" onClick={(event => {
                                event.preventDefault();
                                this.handleCloseModal();
                            })}>Close ✕</a>

                            <div className="modalContent">
                                {this.state.modalContent}
                            </div>

                        </ReactModal>

                        <ToastContainer />

                        <footer className="text-center">

                            <div className="auditedByTitle">
                                Audited by
                                <a id="containerLogoCertik" target="_blank" href="">
                                    <img id="logoCertik" src="/certik.svg" alt=""/>
                                </a>
                            </div>


                            <div className="text-center xtralionFinanceIsAFullyText">
                                Cryptogirl.finance complies with all Identity Verification and Anti Money Laundering.
                            </div>

                            <div className="footerMenu">
                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">RoadMap</a>

                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">Docs</a>

                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">Telegram EN</a>

                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">Telegram ES</a>

                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">Twitter</a>

                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">Telegram</a>

                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">Audit</a>

                                <a target="_blank" href="https://xtralion.gitbook.io/superlion-finance/">Github</a>
                            </div>

                        </footer>

                        <div id="alertsContainer">
                            {wrongNetworkAlert}
                            {noResposability}
                        </div>

                    </div>
                </ScrollToTop>
            </Router>
        );
    }
}

export default App;
